export default {
  // 查询流程节点详情
  selectYgNodeByNodeId: '/ygsjzs/ygNode/selectYgNodeByNodeId',
  // 查询流程节点列表
  selectYgNodeByList: '/ygsjzs/ygNode/selectYgNodeByList',
  // 修改流程节点
  updateYgNode: '/ygsjzs/ygNode/updateYgNode'

}
